import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "sonner";
import {
  fetchPostList,
  fetchReportedPosts,
  blockUnblockPost,
  deletePost,
  fetchPostReports,
  pinUnpinPost,
} from "src/services/post.service";

interface FetchPostListPayload {
  page: number;
  limit: number;
  search?: string;
}

export const doFetchPostList = createAsyncThunk(
  "post/fetchPostList",
  async (payload: FetchPostListPayload) => {
    try {
      const response: any = await fetchPostList({
        page: payload.page,
        limit: payload.limit,
        search: payload.search,
      });
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch post list";
      console.log(errorMessage);
      throw errorMessage;
    }
  }
);

export const doFetchReportedPosts = createAsyncThunk(
  "post/fetchReportedPosts",
  async (payload: FetchPostListPayload) => {
    try {
      const response: any = await fetchReportedPosts({
        page: payload.page,
        limit: payload.limit,
        search: payload.search,
      });
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch reported posts";
      console.log(errorMessage);
      throw errorMessage;
    }
  }
);

export const doFetchPostReports = createAsyncThunk(
  "post/fetchPostReports",
  async (pid: string) => {
    try {
      const response: any = await fetchPostReports(pid);
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch post reports";
      console.log(errorMessage);
      throw errorMessage;
    }
  }
);

export const doBlockUnblockPost = createAsyncThunk(
  "post/blockUnblockPost",
  async (pid: string) => {
    try {
      const response: any = await blockUnblockPost(pid);
      toast.success(response.message);
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to block/unblock post";
      toast.error(errorMessage);
      throw errorMessage;
    }
  }
);

export const doPinUnpinPost = createAsyncThunk(
  "post/pinUnpinPost",
  async (pid: string) => {
    try {
      const response: any = await pinUnpinPost(pid);
      toast.success(response.message);
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data.message || "Failed to pin/unpin post";
      toast.error(errorMessage);
      throw errorMessage;
    }
  }
);

export const doDeletePost = createAsyncThunk(
  "post/deletePost",
  async (pid: string) => {
    try {
      const response: any = await deletePost(pid);
      toast.success(response.message);
      return { pid, ...response };
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to delete post";
      toast.error(errorMessage);
      throw errorMessage;
    }
  }
);
